import { CurrencyCode } from "Infrastructure/Models/CurrencyCodes";
import BigNumber from "bignumber.js";

export const formatCurrencyShortText = (value: number) => {
  const nbsp: string = "\u00A0";

  if (value >= 1_000_000) {
    const mil = (value / 1_000_000).toFixed(1).replace(".", ",").replace(",0", "");
    return `${mil}${nbsp}mil.${nbsp}Kč`;
  }
  if (value >= 1_000) {
    const tis = (value / 1_000).toFixed(1).replace(".", ",").replace(",0", "");
    return `${tis}${nbsp}tis.${nbsp}Kč`;
  }
  return `${value?.toLocaleString("cs-CZ")}${nbsp}Kč`;
};

export const formatCurrency = (
  value: number | null | undefined,
  currencyCode: CurrencyCode | string | null | undefined,
  decimalPlaces = 2,
) => {
  const locales = () => {
    switch (currencyCode) {
      case CurrencyCode.EUR:
        return "sk-SK";
      case CurrencyCode.CHF:
        return "fr-CH";
      case CurrencyCode.GBP:
        return "en-GB";
      case CurrencyCode.USD:
        return "en-US";
      case CurrencyCode.PLN:
        return "pl-PL";

      default:
        return "cs-CZ";
    }
  };

  const formatter = new Intl.NumberFormat(locales(), {
    style: "currency",
    currency: currencyCode ?? CurrencyCode.CZK,
    maximumFractionDigits: decimalPlaces,
    minimumFractionDigits: 0,
  });
  return formatter.format(value ?? 0);
};

export const formatCurrencyWithoutCode = (value: number | null | undefined, decimalPlaces = 2) => {
  const formatter = new Intl.NumberFormat("cs-CZ", {
    style: "decimal",
    maximumFractionDigits: decimalPlaces,
    minimumFractionDigits: 0,
    useGrouping: true,
  });

  const formatted = formatter.format(value ?? 0);
  return formatted.replace(/\s/g, " ").trim();
};

export const getCurrencySymbol = (currency?: CurrencyCode) => {
  if (currency) {
    return formatCurrency(0, currency).replace(/\d/g, "").trim();
  }

  return currency;
};

export function roundHalfUp(value: number) {
  return new BigNumber(value).decimalPlaces(2, BigNumber.ROUND_HALF_UP).toNumber();
}
